export default function SecuritySection() {
  const tips = [
    'Verifica sempre le informazioni',
    'Utilizza connessioni HTTPS',
    'Proteggi i dati personali',
    'Controlla recensioni e fonti',
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            Itaobuy Spreadsheet è sicuro?
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            La sicurezza è una priorità. Prima di utilizzare qualsiasi piattaforma online:
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
          {tips.map((tip, idx) => (
            <div key={idx} className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                <i className="ri-shield-check-line text-base"></i>
              </span>
              <span className="text-sm font-medium text-foreground-800">{tip}</span>
            </div>
          ))}
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
            La sicurezza durante gli acquisti online è una priorità assoluta. Quando utilizzi Itaobuy Spreadsheet per cercare prodotti, segui queste linee guida per proteggerti: verifica sempre l'autenticità delle informazioni prima di procedere con un acquisto, utilizza esclusivamente connessioni HTTPS sicure durante la navigazione, non condividere mai i tuoi dati personali o bancari su piattaforme non verificate, e consulta sempre le recensioni e le valutazioni di altri acquirenti per avere un quadro completo della qualità del prodotto e dell'affidabilità del venditore.
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
            Itaobuy Spreadsheet ti fornisce tutti gli strumenti necessari per fare acquisti informati: dalle QC Photos che mostrano il prodotto reale, alle guide dettagliate in italiano che ti spiegano ogni aspetto del processo di acquisto, fino ai consigli pratici per riconoscere prodotti di qualità. Ricorda sempre che la tua sicurezza online dipende anche dalle tue abitudini: utilizza password robuste, attiva l'autenticazione a due fattori quando disponibile e mantieni aggiornato il tuo browser.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 rounded-lg bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Visita itaobuy sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 rounded-lg border border-background-300/60 text-foreground-700 text-sm font-semibold hover:bg-background-200/50 transition-colors whitespace-nowrap cursor-pointer"
            >
              buy it now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}